import { useState } from 'react'
import { Link, useSearchParams, useNavigate } from 'react-router-dom'
import { authAPI } from '../services/api'

const ResetPasswordPage = () => {
  const [searchParams] = useSearchParams()
  const resetToken = searchParams.get('token')

  const [password, setPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [error, setError] = useState('')
  const [submitting, setSubmitting] = useState(false)

  const navigate = useNavigate()

  // If no token in URL, show an error state
  if (!resetToken) {
    return (
      <div className="auth-page">
        <div className="auth-card">
          <div className="auth-logo">
            <h1>MARTEU</h1>
            <p>Freight Quote System</p>
          </div>

          <div className="auth-error">
            Invalid or missing reset token. Please request a new password reset link.
          </div>

          <div className="auth-link">
            <Link to="/admin/forgot-password">Request new reset link</Link>
          </div>
        </div>
      </div>
    )
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setError('')

    // Validate password length
    if (password.length < 8) {
      setError('Password must be at least 8 characters long.')
      return
    }

    // Validate passwords match
    if (password !== confirmPassword) {
      setError('Passwords do not match.')
      return
    }

    setSubmitting(true)

    try {
      await authAPI.resetPassword(resetToken, password)
      // Redirect to login with success message via location state
      navigate('/admin/login', {
        replace: true,
        state: { message: 'Password reset successfully. Please sign in with your new password.' }
      })
    } catch (err) {
      const message = err.response?.data?.message || err.message || 'Failed to reset password. Please try again.'
      setError(message)
    } finally {
      setSubmitting(false)
    }
  }

  return (
    <div className="auth-page">
      <div className="auth-card">
        <div className="auth-logo">
          <h1>MARTEU</h1>
          <p>Freight Quote System</p>
        </div>

        {error && (
          <div className="auth-error">{error}</div>
        )}

        <form className="auth-form" onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="password">New Password</label>
            <input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Minimum 8 characters"
              required
              minLength={8}
              autoComplete="new-password"
              autoFocus
            />
          </div>

          <div className="form-group">
            <label htmlFor="confirmPassword">Confirm Password</label>
            <input
              id="confirmPassword"
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              placeholder="Re-enter your password"
              required
              minLength={8}
              autoComplete="new-password"
            />
          </div>

          <button
            type="submit"
            className="auth-button"
            disabled={submitting}
          >
            {submitting ? 'Resetting...' : 'Reset Password'}
          </button>
        </form>

        <div className="auth-link">
          <Link to="/admin/login">Back to Login</Link>
        </div>
      </div>
    </div>
  )
}

export default ResetPasswordPage
